import { mountVueComponent } from "@/app";
import EventsGridProxy from "@/components/proxy/EventsGridProxy.vue";

mountVueComponent(EventsGridProxy, "#inc-events-grid");
